export const truncate = (text, length, clamp) => {
  if (!text) {
    return '';
  }
  return text.slice(0, length) + (length < text.length ? clamp || '...' : '');
};
